module.exports = __webpack_public_path__ + "static/architecture-c3ef057fcb59513a99765ef129e9c8b7.jpg";